import React from 'react';

/**
 * CarouselContext
 * {
 *  direction: PropTypes.oneOf(['start', 'end']).isRequired,
 * }
 */
export var CarouselContext = /*#__PURE__*/React.createContext({});


//////////////////
// WEBPACK FOOTER
// ./node_modules/reactstrap/esm/CarouselContext.js
// module id = 229
// module chunks = 0